import styled, { css } from "styled-components";
import { Select } from "@mui/material/";
import MenuItem from "@mui/material/MenuItem";
import theme from "../../../styles/theme";

// Tipagem para StyledSelect
interface StyledSelectProps {
  fontColor?: string;
}

export const StyledSelect = styled(Select) <StyledSelectProps>`
  border-radius: 8px;
  height: 44px;
  padding: 0 24px;
  border: 1px solid ${theme.colors.palete.gold};

  & > .MuiSelect-select {
    padding-left: 8px;
    color: ${(props) => props.fontColor || "white"}; /* Usando fontColor ou 'white' */
  }
  & .MuiSelect-icon {
    color: ${theme.colors.palete.gold};
  }
  &.Mui-focused {
    border: 1px solid ${theme.colors.palete.gold};
    box-shadow: none;
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`;

// Tipagem para StyledMenuItem
interface StyledMenuItemProps {
  isFirst?: boolean;
  isLast?: boolean;
  fontColor?: string; // Nova propriedade adicionada
}

export const StyledMenuItem = styled(MenuItem) <StyledMenuItemProps>`
  padding: 8px 16px;
  color: ${(props) => props.fontColor || "white"}; /* Usando fontColor ou 'white' */

  ${(props) =>
    props.isFirst &&
    css`
      margin-top: -1vh;
      padding-top: 1vh;
    `}

  ${(props) =>
    props.isLast &&
    css`
      margin-bottom: -1.1vh;
      padding-bottom: 1.1vh;
    `}

  &[aria-disabled="true"] {
    font-style: italic;
    color: ${theme.colors.palete.gold}; /* Mantendo cor para itens desabilitados */
  }
`;
